<template>
  <base-model :show="!!error" title="An error occurred" @close="handleError">
    <p>{{ error }}</p>
  </base-model>
  <base-model :show="isLoading" title="Wait we are updating..." fixed>
    <base-spinner></base-spinner>
  </base-model>
  <li>
    <div class="actions">
      <span @click="changeTaskMode" v-if="mode" class="edit">Open</span>
      <span @click="changeTaskMode" v-else class="delete">Completed</span>
    </div>
    <span class="warning" v-if="!mode">This task is Completed</span>
    <h3>{{ task }}</h3>
    <span class="date">{{ date }}</span>
    <p>{{ desc }}</p>
    <div class="box">
      <label>Assign To</label>
      <span class="selectedName" v-for="asign in assignTo" :key="asign">{{
        asign.name
      }}</span>
    </div>
    <div class="feedBack">
      <label><b>FeedBack</b></label>
      <ul class="feeds">
        <li v-for="feed in feeds" :key="feed">
          <p>
            <b>{{ feed.feedBy }}</b>
          </p>
          <p class="comment">{{ feed.comment }}</p>
          <span class="Commentdate">{{ feed.Commentdate }}</span>
        </li>
      </ul>
      <div class="reply" v-if="mode">
        <form @submit.prevent="submitReplie">
          <div class="inputbox">
            <textarea v-model.trim="replie"></textarea>
          </div>
          <div class="btn"><base-button>Reply</base-button></div>
        </form>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: ["id", "task", "desc", "feeds", "mode", "date", "tId", "assignTo"],
  data() {
    return {
      replie: "",
      updateMode: this.mode,
      error: null,
      isLoading: false,
    };
  },
  watch:{
    mode(value, oldVal){
      if(value != oldVal){
        this.updateMode = this.mode;
      }
    }
  },
  methods: {
    async changeTaskMode() {
      this.updateMode = !this.updateMode;
      const rawData = {
        taskId: this.id,
        id: this.tId,
        mode: this.updateMode,
      };
      this.isLoading = true;
      try {
        await this.$store.dispatch("task/updateMode", rawData);
      } catch (err) {
        this.error = err.message || "Failed to Update please try again";
      }
      this.isLoading = false;
    },

    submitReplie() {
      if (this.replie == "") {
        return;
      }
      const rawData = {
        taskId: this.id,
        id: this.tId,
        replie: this.replie,
      };
      this.$store.dispatch("task/addReplie", rawData);
      this.replie = "";
    },
    handleError() {
      this.error = null;
    },
  },
};
</script>

<style scoped>
.actions {
  width: 100%;
  position: relative;
  float: left;
  margin-bottom: 15px;
  text-align: right;
}
.edit {
  border-radius: 5px;
  padding: 5px 10px;
  color: #fff;
  background: green;
  display: inline-block;
  cursor: pointer;
}
.delete {
  border-radius: 5px;
  padding: 5px 10px;
  color: #fff;
  background: red;
  display: inline-block;
  cursor: pointer;
}
.selectedName {
  background: #313131;
  padding: 4px 10px;
  margin-right: 10px;
  color: #fff;
  border-radius: 2px;
}
.box {
  margin-bottom: 15px;
  background: #f1f1f1;
}
.box label {
  width: 100%;
  float: left;
  margin-bottom: 10px;
  font-weight: bold;
}
li,
.box {
  list-style: none;
  width: 100%;
  text-align: left;
  border-radius: 5px;
  border: 1px solid #c1c1c1;
  box-sizing: border-box;
  padding: 20px;
  float: left;
}
li ul li {
  padding: 5px;
  margin-bottom: 10px;
  float: left;
  width: 100%;
  box-sizing: border-box;
}
li ul {
  margin: 20px 0px;
  padding: 0px;
  float: left;
  width: 100%;
  box-sizing: border-box;
}
li ul li:last-child {
  margin-bottom: 0px;
}
.reply {
  width: 100%;
  float: left;
}
.inputbox {
  float: left;
  width: 70%;
}
.inputbox textarea {
  width: 100%;
  border: 1px solid #c1c1c1;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
  float: left;
}
.btn {
  float: right;
  text-align: right;
  width: 30%;
}
.warning {
  color: red;
}
.date,
.Commentdate {
  font-size: 14px;
  padding: 5px 0px;
}
</style>
